import { useEffect, useState } from 'react';

import Config from '../core/Config';

export const useSidebarSP = (): [isOpen: boolean, _setIsOpen: (isOpen: boolean) => void] => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const config: Config = (window as any).__hugotconfig__;
    if (!(config && config.APP_MENU_CUSTOMER_WEBCLIENT_LINK)) {
      return;
    }
    window.addEventListener('message', function (event) {
      if (typeof event.data !== 'string') {
        return;
      }
      // only accept menu-SPA
      if (config.APP_MENU_CUSTOMER_WEBCLIENT_LINK.indexOf(event.origin) === 0) {
        if (event.data === 'sidebarOpen') {
          setIsOpen(true);
        } else if (event.data === 'sidebarClose') {
          setIsOpen(false);
        }
      }
    });
  }, []);

  const setSidebarSPOpen = (isOpen: boolean) => {
    setIsOpen(isOpen);
  };

  return [isOpen, setSidebarSPOpen];
};
